export default __webpack_public_path__ + "src/images/sections/1ddcd47e9e41d420a8febc02673682f0-discover.jpg";